module.exports = __webpack_public_path__ + "static/media/export-data.26800260.png";